// extracted by mini-css-extract-plugin
module.exports = {"singlelist":"Li_singlelist__nZ1d9","icondiv":"Li_icondiv__Vnvbj","left":"Li_left__Yvx9_","right":"Li_right__RhOHw","listext":"Li_listext__h6m2y"};